import { InMemoryCache } from "@apollo/client"

const apolloCache = new InMemoryCache({
  possibleTypes: {
    Marker: ["DeployMarker", "NotificationMarker", "CustomMarker"],
    Incident: ["PerformanceIncident", "ExceptionIncident"],
    Visual: ["VisualTimeseries", "VisualNumber"],
  },
  typePolicies: {
    Logs: {
      merge: true,
    },
  },
})

export { apolloCache }
